(function hookDefineForThemeScroll(){
  if (window.__bbThemeScrollHooked) return;
  window.__bbThemeScrollHooked = true;

  var origDefine = customElements.define.bind(customElements);

  function guardProto(Ctor){
    var P = Ctor.prototype;

    // helper
    function qs(root, sel){ try { return root.querySelector(sel); } catch(e){ return null; } }

    // connectedCallback: ensure viewport exists; bail if not
    var _connected = P.connectedCallback;
    P.connectedCallback = function(){
      this.viewport = this.viewport || qs(this, '.theme-scroll--inner');
      try {
        if (window.OverlayScrollbarsGlobal && window.OverlayScrollbarsGlobal.OverlayScrollbars) {
          window.OverlayScrollbarsGlobal.OverlayScrollbars({
            target: this, elements: { viewport: this.viewport }
          }, {});
        }
      } catch(_) {}
      if (!this.viewport) return;            // ← prevents null target later
      try { return _connected.apply(this, arguments); } catch(_) {}
    };

    // init: require viewport & at least one slide
    var _init = P.init;
    P.init = function(){
      try { this.setSlides && this.setSlides(); } catch(_) {}
      if (!this.viewport || !this.slides || this.slides.length < 1) return;
      try { return _init.apply(this, arguments); } catch(_) {}
    };

    // setListeners: attach only if targets exist
    var _set = P.setListeners;
    P.setListeners = function(){
      try {
        this.nav     = this.nav     || qs(this, '.theme-scroll-nav');
        this.navPrev = this.navPrev || qs(this, '.flickity-prev');
        this.navNext = this.navNext || qs(this, '.flickity-next');

        if (this.nav)      this.nav.addEventListener('click', this.onNavClick.bind(this));
        if (this.viewport) {
          this.debouncedOnScroll = this.debouncedOnScroll || ((e)=>this.onScroll(e));
          this.viewport.addEventListener('scroll', this.debouncedOnScroll, { passive: true });
          this.viewport.addEventListener('resize', this.debouncedOnScroll);
        }
        if (this.resizeObserver && this.slides && this.slides[0]) {
          this.resizeObserver.observe(this.slides[0]);
        }
      } catch(_) {}
      try { return _set.apply(this, arguments); } catch(_) {}
    };

    // onScroll: guard viewport
    if (typeof P.onScroll === 'function') {
      var _scroll = P.onScroll;
      P.onScroll = function(){ if (!this.viewport) return; try { return _scroll.apply(this, arguments); } catch(_){} };
    }

    // centerArrows: guard slide indexing
    if (typeof P.centerArrows === 'function') {
      var _center = P.centerArrows;
      P.centerArrows = function(){ if (!this.slides || !this.slides.length) return; try { return _center.apply(this, arguments); } catch(_){} };
    }
  }

  customElements.define = function(name, Ctor, opts){
    if (name === 'theme-scroll') {
      try { guardProto(Ctor); } catch(_) {}
    }
    return origDefine(name, Ctor, opts);
  };

  // If already defined (rare if this runs before app.js), patch existing too:
  try {
    var Existing = customElements.get('theme-scroll');
    if (Existing && !Existing.__bbGuarded) { guardProto(Existing); Existing.__bbGuarded = true; }
  } catch(_) {}
})();